import { render, staticRenderFns } from "./ClientMemberManage.vue?vue&type=template&id=5083daa0&scoped=true&"
import script from "./ClientMemberManage.vue?vue&type=script&lang=js&"
export * from "./ClientMemberManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083daa0",
  null
  
)

export default component.exports